import React from 'react';
export const Story = () => {
  return <div className="py-16 bg-white relative" data-id="element-216">
      {/* Subtle corner element */}
      <div className="absolute top-0 right-0 w-16 h-16 md:w-24 md:h-24 overflow-hidden opacity-20" data-id="element-217">
        <div className="relative w-full h-full" data-id="element-218">
          {/* Symbolic elements */}
          <div className="absolute top-0 left-0 w-full h-full flex flex-col" data-id="element-219">
            {[...Array(13)].map((_, i) => <div key={i} className={`w-full ${i % 2 === 0 ? 'bg-red-700' : 'bg-gray-200'}`} style={{
            height: `${100 / 13}%`
          }} data-id="element-220"></div>)}
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-221">
        <p className="text-lg text-gray-700 mb-8" data-id="element-222">
          From Columbine to Sandy Hook, Parkland to Uvalde, and the most recent
          tragedies in 2024, this book asks the questions politicians avoid and
          parents fear:
        </p>
        <div className="my-8" data-id="element-223">
          <p className="text-xl font-bold text-center text-gray-800 mb-4" data-id="element-224">
            Why does it keep happening?
          </p>
          <p className="text-xl font-bold text-center text-gray-800 mb-4" data-id="element-225">
            Who ignored the warning signs?
          </p>
          <p className="text-xl font-bold text-center text-gray-800 mb-4" data-id="element-226">
            What will it take to stop it?
          </p>
        </div>
        <p className="text-lg text-gray-700 mb-12" data-id="element-227">
          <span className="italic font-medium" data-id="element-228">
            When Schools Become Targets
          </span>{' '}
          isn't entertainment — it's an indictment of silence, a record of lives
          cut short, and a roadmap toward the action America keeps postponing.
        </p>
        <div className="bg-gray-100 border-l-4 border-red-700 p-6 mb-12" data-id="element-229">
          <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-230">
            <span className="text-red-700 mr-2" data-id="element-231">★</span>A book born from pain —
            and rage
          </h3>
          <p className="text-lg text-gray-700 mb-4" data-id="element-232">
            The prologue opens with the reality no parent wants to face:
            backpacks without owners, classrooms silenced by bullets, and
            speeches that sound emptier with every tragedy.
          </p>
          <blockquote className="text-xl italic font-medium text-gray-800 pl-4 border-l-4 border-red-700 my-6" data-id="element-233">
            "This isn't a lament. It's evidence."
          </blockquote>
          <p className="text-lg text-gray-700" data-id="element-234">
            Every page confronts the uncomfortable truth: these tragedies
            continue because we allow them to. The book documents not just what
            happened, but what we failed to do afterward.
          </p>
        </div>
        <div className="flex justify-center my-12 relative" data-id="element-235">
          <div className="absolute inset-0 rounded-lg border-4 border-transparent bg-gradient-to-r from-red-700 via-gray-300 to-gray-700 opacity-30" data-id="element-236"></div>
          <img src="https://images.unsplash.com/photo-1588072432836-e10032774350?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1772&q=80" alt="Empty school hallway" className="w-full max-w-2xl rounded-lg shadow-lg relative z-10" data-id="element-237" />
        </div>
      </div>
    </div>;
};